const TimeSlotSelectionPopup = ({
  setOpen,
  timeSlots,
  selectedSlot,
  setSelectedSlot,
  disabledSlotIds,
  onSave,
  isEditing,
}) => {
  console.log("timeSlots--->", timeSlots);

  return (
    <div className="img-popup-design">
      <div
        className="img-popup"
        style={{
          width: "60%",
        }}
      >
        <div className="d-flex as-jb">
          <div>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2 text-start">
              {isEditing ? "Edit Time Slot & Price" : "Add Time Slot & Price"}
            </p>
            <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2 gray">
              Set slot duration , Pricing, and available days.
            </p>
          </div>
          <p
            className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 pointer"
            onClick={() => setOpen(false)}
          >
            X
          </p>
        </div>

        <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 my-3 gray text-start">
          Slot Duration
        </p>

        <div className="d-flex flex-wrap gap-1">
          {timeSlots?.map((i) => {
            const taken = disabledSlotIds?.includes(i?.id);
            return (
              <div
                key={i?.id}
                className={`${i?.id === selectedSlot?.slot ? "prim-btn" : "sec"} f4 p-2 my-2`}
                style={{
                  opacity: taken ? 0.4 : 1,
                  cursor: taken ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (taken) return;
                  setSelectedSlot((prev) => ({ ...prev, slot: i?.id }));
                }}
              >
                {i?.display_name?.trim() ? i?.display_name : "-"}
                <p>{`${i?.start_time} - ${i?.end_time}`}</p>
              </div>
            );
          })}
        </div>

        <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 my-2 gray text-start">
          Pricing
        </p>

        <p className="text-start f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
          Base Price<span style={{ color: "red" }}>*</span>
        </p>
        <input
          className="input-box"
          value={selectedSlot?.basePrice}
          onChange={(e) => {
            if (e.target.value.length > 5) {
              return;
            } else {
              setSelectedSlot((prev) => ({
                ...prev,
                basePrice: e.target.value,
              }));
            }
          }}
          type="Number"
          placeholder="Enter Base Price"
        />

        <button className="submit-btn w-100 my-3" onClick={onSave}>
          {isEditing ? "Update Slot" : "Save Slot"}
        </button>
      </div>
    </div>
  );
};

export default TimeSlotSelectionPopup;
